import React from 'react';
import { Battery, QrCode, FileText, User } from 'lucide-react';

import {useRouter} from '../../providers/Router/RouterProvider';

import './styles.css';

export const HomeScreen = () => {
  const { navigate } = useRouter();
  const handleCharge = () => navigate('scanner');
  return (
    <div className='container mx-auto max-w-sm'>
      <div className="HomeScreen bg-background text-gray-800 h-screen p-4 flex flex-col">

        <div className='flex-1 flex flex-col gap-1 justify-between'>
          <div className="">
            <h1 className="text-3xl font-bold text-[#ff571e]">Total Energy</h1>
            <p className="text-xl text-gray-600">Your charging session overview</p>
          </div>

          <div className="bg-white rounded-lg p-4 mb-4 shadow-md">
            <h2 className="text-xl mb-2 font-semibold">Last Session</h2>
            <div className="flex justify-between mb-2">
              <div className="bg-gray-100 p-2 rounded flex-1 mr-2">
                <p className="text-gray-600">Cost</p>
                <p className="text-xl font-semibold">$4.32</p>
              </div>
              <div className="bg-gray-100 p-2 rounded flex-1 ml-2">
                <p className="text-gray-600">Energy</p>
                <p className="text-xl font-semibold">10.67 kWh</p>
              </div>
            </div>
            <h2 className="text-xl mb-2 font-semibold">This Month</h2>
            <div className="flex justify-between">
              <div className="bg-gray-100 p-2 rounded flex-1 mr-2">
                <p className="text-gray-600">Cost</p>
                <p className="text-xl font-semibold">$20.96</p>
              </div>
              <div className="bg-gray-100 p-2 rounded flex-1 ml-2">
                <p className="text-gray-600">Energy</p>
                <p className="text-xl font-semibold">61.78 kWh</p>
              </div>
            </div>
          </div>

          <button className="w-full bg-primary text-white py-3 rounded-xl text-2xl flex items-center justify-center px-6 py-3 mb-10 transition-colors duration-200 active:bg-primary-dark" onClick={handleCharge}>
            <span className="mr-2 scale-125"><QrCode /></span>
            <span>Scan a QR code to Start Charging</span>
          </button>
        </div>

        <div className="mt-auto flex justify-between">
          <button className="flex flex-col items-center text-primary transition-colors">
            <Battery className="mb-1" />
            <span>Charge</span>
          </button>
          <button className="flex flex-col items-center text-gray-600 transition-colors">
            <FileText className="mb-1" />
            <span>History</span>
          </button>
          {/* <button className="flex flex-col items-center text-gray-600 transition-colors">
            <Building2 className="mb-1" />
            <span>Property</span>
          </button> */}
          <button className="flex flex-col items-center text-gray-600 transition-colors">
            <User className="mb-1" />
            <span>Profile</span>
          </button>
        </div>
      </div>
    </div>
  );
}